(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@feature-hub/react"), require("@oneaudi/unified-web-common"), require("react"), require("styled-components"));
	else if(typeof define === 'function' && define.amd)
		define(["@feature-hub/react", "@oneaudi/unified-web-common", "react", "styled-components"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("@feature-hub/react"), require("@oneaudi/unified-web-common"), require("react"), require("styled-components")) : factory(root["@feature-hub/react"], root["@oneaudi/unified-web-common"], root["react"], root["styled-components"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, (__WEBPACK_EXTERNAL_MODULE__544__, __WEBPACK_EXTERNAL_MODULE__536__, __WEBPACK_EXTERNAL_MODULE__155__, __WEBPACK_EXTERNAL_MODULE__694__) => {
return 